import { render, staticRenderFns } from "./workSituation.vue?vue&type=template&id=d43a5afe&"
import script from "./workSituation.vue?vue&type=script&lang=js&"
export * from "./workSituation.vue?vue&type=script&lang=js&"
import style0 from "./workSituation.vue?vue&type=style&index=0&id=d43a5afe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports